






























import { defineComponent, SetupContext, PropType } from '@vue/composition-api'
import AtomsInputRadioBasicInfo from '@/components/pages/children/utils/AtomsInputRadioBasicInfo.vue'
export type FuncInputViewChildFlgType = (
  setKey: string,
  inputValue: string
) => void

export default defineComponent({
  props: {
    label: {
      type: String,
      required: false,
    },
    viewChildFlg: {
      type: String,
      required: true,
    },
    setKey: {
      type: String,
      required: true,
    },
    handleInputViewChildFlg: {
      type: Function as PropType<FuncInputViewChildFlgType>,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    tooltipTextLink: {
      type: String,
      required: false,
      default: '',
    },
    tooltipTitle: {
      type: String,
      required: false,
      default: '',
    },
    tooltipTextArray: {
      type: Array,
      required: false,
      default: () => null,
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: true,
    },
    subText: {
      type: String,
      required: false,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: {
    AtomsInputRadioBasicInfo,
  },
  setup(props, context: SetupContext) {
    return {
      props,
      context,
    }
  },
})
